import axios from "axios";

const getApiEndPoint = (mode) => {
  // console.log("inside getApiEndPoint");
  mode = (mode || "production").toLowerCase().trim();
  const links = {
    'production': "https://jewellery-tectalik-api.tectalik.com/",
    'development': "https://jewellery-tectalik-api-staging.tectalik.com/",
    'local': "http://localhost:4020/",
  };

  return links[mode] ??"http://localhost:4020/";
};

const hostParts = window.location.host.split(".");
const domain = hostParts.slice(-2, -1)[0];
console.log(domain,"domain");
const node_env = process.env.VUE_APP_NODE_ENV || "production";

let exclude_domains = ["orodxb","orobom","oro","orox"];
const api_end_point = (node_env == "production" && exclude_domains.includes(domain) == true)
? "https://oro-jewellery-api.tectalik.com/" : getApiEndPoint(node_env);
// console.log(api_end_point,"api_end_point");
const uri = `${api_end_point}/api/`;
const public_uri = `${api_end_point}/api/`;
const c_public_uri = `${api_end_point}/capi/`;

const tapi = axios.create({
  baseURL: `${uri}`,
  method: "POST",
  headers: {
    Accept: "application/json",
  },
});

const public_api = axios.create({
  baseURL: `${public_uri}`,
  method: "POST",
  headers: {
    Accept: "application/json",
  },
});

const c_public_api = axios.create({
  baseURL: `${c_public_uri}`,
  method: "POST",
  headers: {
    Accept: "application/json",
  },
});

const addHeaders = (config) => {
  var token = localStorage.getItem("TOKEN");
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
};

tapi.interceptors.request.use(addHeaders);
public_api.interceptors.request.use(addHeaders);
c_public_api.interceptors.request.use(addHeaders);
const local_url =`https://localhost:4020/`;

const local_api = axios.create({
  baseURL: `${local_url}`,
  method: "POST",
  headers: {
    Accept: "application/json",
  },
});
// const addHeaders = (config) => {
//   return config;
// };

local_api.interceptors.request.use(addHeaders);

const pos_print_url = `http://localhost:2023/`;

const pos_print_api = axios.create({
  baseURL: `${pos_print_url}`,
  method: "POST",
  headers: {
    Accept: "application/json",
  },
});


pos_print_api.interceptors.request.use(addHeaders);



const pdf_url = `https://pdf-service.tectalik.com/`;

const pdf_gen_api = axios.create({
  baseURL: `${pdf_url}`,
  method: "POST",
  headers: {
    Accept: "application/json",
  },
});

pdf_gen_api.interceptors.request.use(addHeaders);


export { tapi, public_api, c_public_api, local_api, pos_print_api, pdf_gen_api };